var CONFUSEDCMS = CONFUSEDCMS || {},
    CONFUSEDWEBSITE = CONFUSEDWEBSITE || {},
    CONFUSEDCORE = CONFUSEDCORE || {},
    CSSCONSTANTS = CSSCONSTANTS || {};

(function ($) {

  //setup expert search module (google custom search configuration)
  (function () {
      var el = document.getElementById('expertSearch');
      if (el) {
          var searchDetails = {
              searchFormId: 'expertSearch',
              buttonClass: 'contextual-search__submit--expertSearch',
              searchTextId: 'expert-help-question',
              customSearchKeyId: 'googleCustomKey',
              invalidInputSelector: '#query-error'
          };

          CONFUSEDWEBSITE.setupSearch(searchDetails);
      }
  })();

  //setup help header module (google custom search configuration)
  (function () {
      var el = document.getElementById('helpHeader');
      if (el) {
          var searchDetails = {
              searchFormId: 'helpHeader',
              buttonClass: 'searchTextHelp',
              searchTextId: 'searchTextHelp',
              customSearchKeyId: 'googleCustomKey',
              invalidInputSelector: '#query-error'
          };

          CONFUSEDWEBSITE.setupSearch(searchDetails);
      }

  })();



    $(function () {

        //CONFUSEDCORE.MI.MiListener.postLogSession('LogNewSession');
        var pageUrl = window.location.href;
        CONFUSEDCORE.MI.MiListener.postPageView('LogPageView', { page: pageUrl, referer: document.referrer });

        //CONFUSEDCORE.MI.MiListener.pageView($('body').data('mi-pagename'));
        CONFUSEDCMS.contactUsFormSetup($);
        CONFUSEDWEBSITE.expandingPanel();
       
        CONFUSEDWEBSITE.responsiveTables();

        CONFUSEDWEBSITE.setupOverlaps();

        CONFUSEDWEBSITE.backToTopLink();

        CONFUSEDCMS.setupProductDrivers();

        CONFUSEDCMS.responsiveTabs();

        CONFUSEDCMS.setupProviderList();

        CONFUSEDCMS.setupProductTestimonials();

        CONFUSEDCMS.expandingBands();

        CONFUSEDWEBSITE.setupEqualizeHeights();

        CONFUSEDCMS.setupProductCtas();

        if ($('div.mot-checker').length > 0) {
            var motChecker = new CONFUSEDCMS.VehicleDetails.MotChecker();
            var $form =   $('.js-mot-checker');
            motChecker.InitialiseModule($form);
            CONFUSEDCMS.setUpVehicleDetailsCheckerValidation($form);
        }

        if ($('.img--infographic--animated').length > 0) {
            CONFUSEDCMS.priceIndex();
        }

        if ($('div.owl-carousel').length > 0) {
            CONFUSEDCMS.carousel($);
        }

        if ($('.cms-tabs__tab-list').length > 0) {
            CONFUSEDCMS.tabs($);
        }

    });
})(window.jQuery);

// If document has loaded, set up lazy loading of images using Yall library
// If not, add event listener to set up lazy loading once document loaded
(function () {
	if (document.readyState !== 'loading') {
		CONFUSEDCMS.setupLazyLoading();
    }
    else {
		document.addEventListener('DOMContentLoaded', function () {
			CONFUSEDCMS.setupLazyLoading();
        });
    }
})();